// The "who you're rating" card: site thumbnail, "Kick Health", "gokick.com".
//
// variant "rate"   — cream card, framed 56px thumbnail, name + domain (S1).
// variant "thanks" — white bordered card, bare 40×30 thumbnail, 18px name
//                    only, padding 24 (S11's card above the review card).

import { makeStyles } from "@mui/styles";

import { RATING_COLORS } from "~/shared/styles/ratingPalette";
import { SiteThumb } from "./ratingUi.jsx";

const useStyles = makeStyles({
  card: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    backgroundColor: RATING_COLORS.companyCard,
    borderRadius: "16px",
    padding: "16px",
  },
  cardThanks: {
    gap: "12px",
    backgroundColor: "#FFFFFF",
    border: `1px solid ${RATING_COLORS.borderCard}`,
    borderRadius: "8px",
    padding: "24px",
  },
  name: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.5,
    color: RATING_COLORS.textPrimary,
  },
  nameThanks: {
    fontSize: "18px",
    lineHeight: 1.4,
  },
  domain: {
    fontSize: "16px",
    lineHeight: 1.5,
    color: RATING_COLORS.textPrimary,
  },
});

export default function CompanyCard({ variant = "rate", className }) {
  const classes = useStyles();
  const thanks = variant === "thanks";
  return (
    <div
      className={[classes.card, thanks && classes.cardThanks, className]
        .filter(Boolean)
        .join(" ")}
    >
      {thanks ? (
        <SiteThumb framed={false} height={30} />
      ) : (
        <SiteThumb size={56} />
      )}
      <div>
        <div
          className={[classes.name, thanks && classes.nameThanks]
            .filter(Boolean)
            .join(" ")}
        >
          Kick Health
        </div>
        {thanks ? null : <div className={classes.domain}>gokick.com</div>}
      </div>
    </div>
  );
}
